module.exports = require("./it-SM.d.ts");